import { Button, WidgetSizeEnum } from '@wonderschool/common-base-ui';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { getTitlePrefix } from '../config/env';
import { RouteNameEnum, useRoutes } from '../navigation';

const Unauthorized = () => {
  const { t } = useTranslation();
  const { gotoRouteByName } = useRoutes();

  const renderPageHead = () => (
    <Helmet>
      <title>
        {getTitlePrefix()}
        {t('pages.unauthorized.browserTitle')}
      </title>
      <body className="auth error" />
    </Helmet>
  );

  const handleTryAgain = () => {
    // go to home page '/'
    gotoRouteByName(RouteNameEnum.HOME);
  };

  return (
    <div className="m-auto w-96 p-0">
      {renderPageHead()}

      <div className="rounded-lg border border-gray-300 bg-white p-6">
        <h1 className="mb-4 text-2xl font-bold">{t('unauthorized.ohNo')}</h1>

        <p>{t('unauthorized.ohNoMessage')}</p>

        <div className="mb-4">
          <img
            src="https://media.giphy.com/media/9Y5BbDSkSTiY8/giphy.gif"
            style={{ width: '100%' }}
            alt={t('common.YesExclamation')}
          />
        </div>

        <Button
          primary
          size={WidgetSizeEnum.MEDIUM}
          label={t('unauthorized.tryAgain')}
          onClick={handleTryAgain}
          extraClasses="w-full"
        />
      </div>
    </div>
  );
};

export default Unauthorized;
